




























import SmoothPicker from "vue-smooth-picker";
import { MonthPickerVue } from "../../../vueModels/app/datePicker/MonthPickerVue";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/i18n";

Vue.use(SmoothPicker);

@Component
export default class MonthPicker extends MonthPickerVue {
  mounted() {
    this.$forceUpdate();
    this.isMounted = true;
    this.defData = [
      {
        currentIndex: this.years.indexOf(+this.maxDate?.substring(0, 4)),
        list: this.years,
        textAlign: "center"
      },
      {
        currentIndex: null,
        list: i18n.t("common.months"),
        textAlign: "center"
      }
    ];
    this.getDefValue();
  }
}
